import { createReducer } from '@reduxjs/toolkit';
import initialState from 'store/initialState';
import * as Actions from './actions';

const integrations = createReducer(initialState.integrations, {
  [Actions.getCredentials.SUCCESS]: (state, action) => {
    state.credentials = action.payload;
  },
  [Actions.patchCredentials.SUCCESS]: (state, action) => {
    state.credentials = action.payload;
  },
});

export { integrations as reducer };




